import Spinner from "./Spinner";

const STEPS = [
  { key: "queued",       label: "Fetching post…"       },
  { key: "downloading",  label: "Downloading media…"   },
  { key: "transcribing", label: "Transcribing videos…" },
  { key: "analyzing",   label: "Analyzing with AI…"   },
  { key: "complete",    label: "Complete!"             },
];

const STATUS_ORDER = ["queued", "downloading", "transcribing", "analyzing", "complete"];

function stepState(step, currentStatus, progress) {
  const currentIdx = STATUS_ORDER.indexOf(currentStatus);
  const stepIdx    = STATUS_ORDER.indexOf(step.key);
  if (currentStatus === "failed") return "idle";
  if (stepIdx < currentIdx) return "done";
  if (stepIdx === currentIdx) return progress >= 100 ? "done" : "active";
  return "idle";
}

function StepIcon({ state }) {
  if (state === "done")
    return (
      <span className="flex items-center justify-center w-7 h-7 rounded-full bg-green-500/20 text-green-400 text-sm font-bold shrink-0">
        ✓
      </span>
    );
  if (state === "active")
    return (
      <span className="flex items-center justify-center w-7 h-7 rounded-full bg-indigo-500/10 shrink-0">
        <Spinner size="sm" />
      </span>
    );
  return (
    <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#2e2e2e] shrink-0">
      <span className="w-2 h-2 rounded-full bg-[#444]" />
    </span>
  );
}

export default function ProgressTracker({ status, progress }) {
  const failed = status === "failed";

  return (
    <div className="w-full max-w-lg mx-auto">
      {/* Animated progress bar */}
      <div className="h-1.5 w-full bg-[#2e2e2e] rounded-full mb-8 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-700 ease-out ${
            failed ? "bg-red-500" : "bg-indigo-500"
          }`}
          style={{ width: `${failed ? 100 : progress}%` }}
        />
      </div>

      {/* Steps */}
      <ol className="space-y-4">
        {STEPS.map((step) => {
          const state = stepState(step, status, progress);
          return (
            <li key={step.key} className="flex items-center gap-4">
              <StepIcon state={state} />
              <span
                className={`text-base transition-colors duration-300 ${
                  state === "done"   ? "text-green-400 font-medium" :
                  state === "active" ? "text-white font-medium"     :
                  "text-[#555]"
                }`}
              >
                {step.label}
              </span>
              {state === "active" && (
                <span className="ml-auto text-sm text-indigo-400 tabular-nums font-mono">
                  {progress}%
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
